export default __webpack_public_path__ + "static/media/loyola5.f18f6baf.jpg";